import { render, staticRenderFns } from "./TarifasTarifario.vue?vue&type=template&id=2c7abf89"
import script from "./TarifasTarifario.vue?vue&type=script&lang=js"
export * from "./TarifasTarifario.vue?vue&type=script&lang=js"
import style0 from "./TarifasTarifario.vue?vue&type=style&index=0&id=2c7abf89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports